import { Component, OnInit } from '@angular/core';
import { EditalService } from '../../services/edital.service';
import { RouteNavigationService } from '../../services/api/route-navigation.service';
import { PMVAuthenticationService, NotificationService } from 'pmv-common';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { delay } from 'q';

@Component({
  selector: 'pmv-home',
  templateUrl: 'home.component.html',
  styleUrls: ['home.component.scss']
})
export class HomeComponent  implements OnInit {
 
  loading: Boolean = false;
  situacoesEdital: any[];

  qtdRetorno: number[];

  qtdAberta: number = 0;
  qtdEmAndamento: number = 0;
  qtdEncerrado: number = 0;
  qtdProximo: number = 0;

  urlDiarioOficial : string = 'https://diariooficial.vitoria.es.gov.br';

  i1:number = 1;
  i2:number = 2;
  
  constructor(private routeDataService: RouteNavigationService,
              private editalService: EditalService,
              private notificationService: NotificationService,
              private authenticationService: PMVAuthenticationService)
  { }

  ngOnInit(): void {
    this.loading = true;
    this.isAuth();
    this.buscarSituacoes(3);
    this.initialize();
  }
  
  initialize(): void {
    this.loading = false;
  }

  isAuth(){
    const canActivate = this.authenticationService.isUserLoggedIn();
    if (canActivate) {
      const type = this.authenticationService.getTypeLoged();
      if (type === 1) {
        this.routeDataService.fromLoginToCandidatoPainel();
      }else {
        this.routeDataService.fromLoginToServidorPainel();
      }
    }
  }
  
  onTabChange(event) {
    const index = event.index;
    if( index == 0){
      this.buscarSituacoes(3);
    }
    else if (index == 1){
      this.buscarSituacoes(1);
    }
  }

  buscarSituacoes(tpConc: number) {
    this.loading = true;
    const http = this.editalService;
    forkJoin(
      http.GetQtdEditalHome(tpConc),
    ).subscribe(res => {
      this.qtdAberta = res[0][0];
      this.qtdEmAndamento = res[0][1];
      this.qtdEncerrado = res[0][2];
      this.qtdProximo = res[0][3];
      this.loading = false;
    }, error => {
      this.loading = false;
      throw this.notificationService.notifyError(error.pipe(delay(10000)), 60000);
    });
  }

  abrirEdital(tipo: number, tpConc: number): void {
    this.routeDataService.fromAnyToEdital(tipo, tpConc);
  }

  abrirDiarioOficial(): void {
    window.open(this.urlDiarioOficial, '_blank');
  }
  
  abrirLogin(): void {
    this.routeDataService.fromAnyToLogin();
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/home/home.component.ts